import { AddTranscodingPublishSettingComponent } from './components/transcoding/transcoding-publish-settings/add-transcoding-publish-setting/add-transcoding-publish-setting.component';
import { UsageReportModule } from './components/report/usage-report/usage-report.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { LoginGuard } from './../login.guard';
import { LoginRouteBlockGuard } from './../login-route-block.guard';
import { PrivilegesGuard, } from './privileges/privileges.guard';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { CmsManagerGuard } from './authguard/cms-manager.guard';



const routes: VexRoutes = [

  {
    path: '',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule),
    canActivate: [LoginRouteBlockGuard]

  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./components/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
    canActivate: [LoginRouteBlockGuard]
  },
  {
    path: '404-not-found',
    loadChildren: () => import('./components/not-found/not-found.module').then(m => m.NotFoundModule),
  },
  {
    path: 'cms',
    component: CustomLayoutComponent,
    children: [

      //business Group
      {
        path:'business-group',
        loadChildren:() => import('./components/businessGroupManagement/business-group/business-group.module').then(m => m.BusinessGroupModule),
        canActivate:[LoginGuard, CmsManagerGuard]
      },
      {
        path:'business-group/add-business-group',
        loadChildren:()=>import('./components/businessGroupManagement/add-business-group/add-business-group.module').then(m=>m.AddBusinessGroupModule),
        canActivate:[LoginGuard, CmsManagerGuard]
      },
      {
        path:'business-group/edit-business-group',
        loadChildren:()=>import('./components/businessGroupManagement/add-business-group/add-business-group.module').then(m=>m.AddBusinessGroupModule),
        canActivate:[LoginGuard, CmsManagerGuard]
      },
      // dashborad
      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [LoginGuard]
      },
      // Catalogs 
      {
        path: 'catalogs',
        loadChildren: () => import('./components/catalogs/catalogs.module').then(m => m.CatalogsModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'catalogs/:id',
        loadChildren: () => import('./components/catalogs/catalog-content/catalog-content.module').then(m => m.CatalogComponentModule),
        canActivate: [LoginGuard]
      },
      
      {
        path: 'catalogs/:theme/:id',
        loadChildren: () => import('./components/catalogs/show-catalog-content/show-catalog-content.module').then(m => m.ShowCatalogContentModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'catalogs/:theme/:showName/subcategory',
        loadChildren: () => import('./components/catalogs/subcategory-list/subcategory-list.module').then(m => m.SubcategoryListModule),
        canActivate: [LoginGuard]
      },
      // show with subcategory episodes
      {
        path: 'catalogs/subcategory/episodes/:show_friendly_id/:subcategory_friendly',
        loadChildren: () => import('./components/catalogs/catalog-content/catalog-content.module').then(m => m.CatalogComponentModule),
        canActivate: [LoginGuard]
      },
      // show with episodes only
      {
        path: 'catalogs/episodes/:show_name/:id',
        loadChildren: () => import('./components/catalogs/catalog-content/catalog-content.module').then(m => m.CatalogComponentModule),
        canActivate: [LoginGuard]
      },
      {
        path:'catalogs/add/new/subcategory/:show_friendlyId',
        loadChildren: () => import('./components/catalogs/subcategory-creation/subcategory-creation.module').then(m => m.SubcategoryCreationModule),
        canActivate: [LoginGuard]
      },
      {
        path:'catalogs/add/edit/subcategory/:content_id/:subcategory_id',
        loadChildren: () => import('./components/catalogs/subcategory-creation/subcategory-creation.module').then(m => m.SubcategoryCreationModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'catalogs/:theme/:showName/:subcategory_friendlyId/episodes',
        loadChildren: () => import('./components/catalogs/show-episode-list/show-episode-list.module').then(m => m.ShowEpisodeListModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'catalogs/:theme/:showName/episodes',
        loadChildren: () => import('./components/catalogs/show-episode-list/show-episode-list.module').then(m => m.ShowEpisodeListModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'catalogs/add/new/show',
        loadChildren: () => import('./components/catalogs/add-new-catalog-content/add-new-catalog-content.module').then(m => m.AddNewCatalogContentModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'catalogs/add/edit/show/:catalog_id/:content_id',
        loadChildren: () => import('./components/catalogs/add-new-catalog-content/add-new-catalog-content.module').then(m => m.AddNewCatalogContentModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'catalogs/new/add-new-content',
        loadChildren: () => import('./components/catalogs/add-new-content/add-new-content.module').then(m => m.AddNewContentModule),
        canActivate: [LoginGuard]
      },
       // add media 
      {
        path: 'catalogs/new/add-media/:catalog_id/:catalog_name',
        loadChildren: () => import('./components/catalogs/add-new-media/add-new-media.module').then(m => m.AddNewMediaModule),
        canActivate: [LoginGuard] 
      },
      //add new live channell
      {
        path: 'catalogs/new/add-live-tv/:catalog_id/:tenant_id',
        loadChildren: () => import('./components/catalogs/add-new-live-tv/add-new-live-tv.module').then(m => m.AddNewLiveTvModule),
        canActivate: [LoginGuard] 
      },

      //edit live channel
      {
        path: 'catalogs/edit/edit-live-tv/:catalog_id/:livetv_id',
        loadChildren: () => import('./components/catalogs/add-new-live-tv/add-new-live-tv.module').then(m => m.AddNewLiveTvModule),
        canActivate: [LoginGuard] 
      },
      //add media for episode with season
      {
        path: 'catalogs/new/subcategory/episode/add-media/:subcategory_id/:show_id/:catalog_name',
        loadChildren: () => import('./components/catalogs/add-new-media/add-new-media.module').then(m => m.AddNewMediaModule),
        canActivate: [LoginGuard] 
      },

      // add media for direct episoded
      {
        path: 'catalogs/new/episode/add-media/:catalog_id/:show_id/:catalog_name',
        loadChildren: () => import('./components/catalogs/add-new-media/add-new-media.module').then(m => m.AddNewMediaModule),
        canActivate: [LoginGuard] 
      },
        // edit media
        {
          path: 'catalogs/edit/edit-media/:catalog_id/:content_id',
          loadChildren: () => import('./components/catalogs/add-new-media/add-new-media.module').then(m => m.AddNewMediaModule),
          canActivate: [LoginGuard]
        },
        // edit media for episode with season
        {
          path: 'catalogs/edit/edit-media/subcategory/:subcategory_id/:catalog_id/:content_id',
          loadChildren: () => import('./components/catalogs/add-new-media/add-new-media.module').then(m => m.AddNewMediaModule),
          canActivate: [LoginGuard]
        },
        //edit media for direct episode
        {
          path: 'catalogs/edit/edit-media/episodes/:catalog_id/:show_id',
          loadChildren: () => import('./components/catalogs/add-new-media/add-new-media.module').then(m => m.AddNewMediaModule),
          canActivate: [LoginGuard]
        },
      //  {
      //   path: 'catalogs/new/add-media',
      //   loadChildren: () => import('./components/catalogs/add-new-catalog-content/add-new-catalog-content.module').then(m => m.AddNewCatalogContentModule),
      //   canActivate: [LoginGuard]
      // },
      
      {
        path: 'catalogs/new/create/catalog',
        loadChildren: () => import('./components/catalogs/add-new-catalog/add-new-catalog.module').then(m => m.AddNewCatalogModule),
        canActivate: [LoginGuard, PrivilegesGuard],
        data:{privilegeKey : 'create_catalog'}
      },
      {
        path: 'catalogs/edit/catalog/:id',
        loadChildren: () => import('./components/catalogs/add-new-catalog/add-new-catalog.module').then(m => m.AddNewCatalogModule),
        canActivate: [LoginGuard, PrivilegesGuard],
        data:{privilegeKey : 'edit_catalog'}
      },

      // Media list 

      {
        path: 'media_list',
        loadChildren: () => import('./components/media-list/media-list.module').then(m => m.MediaListModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'media_list/add_media_list',
        loadChildren: () => import('./components/media-list/add-media-list/add-media-list.module').then(m => m.AddMediaListModule),
        canActivate: [LoginGuard,PrivilegesGuard],
        data:{privilegeKey : 'create_media_list'}
      },
      {
        path: 'media_list/add_media_list/:media_list_id/:media_list_type/:media_list_title',
        loadChildren: () => import('./components/media-list/add-media-list/add-media-list.module').then(m => m.AddMediaListModule),
        canActivate: [LoginGuard,PrivilegesGuard],
        data:{privilegeKey : 'edit_media_list'}
      },
      {
        path: 'view_all_media_list',
        loadChildren: () => import('./components/media-list/media-list-view-all/media-list-view-all.module').then(m => m.MediaListViewAllModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'new_all_media_list',
        loadChildren: () => import('./components/media-list/media-list-view-new/media-list-view-new.module').then(m => m.MediaListViewNewModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'media_list/details/:list_id',
        loadChildren: () => import('./components/media-list/media-list-details/media-list-details.module').then(m => m.MediaListDetailsModule),
        canActivate: [LoginGuard]
      },

      //All Contents
      {
        path: 'all-contents',
        loadChildren: () => import('./components/content_management/all-contents/all-contents.module').then(m => m.AllContentsModule),
        canActivate: [LoginGuard]
      },

      // Adminstration 

        // User management 

        {
          path: 'user_managment/all_users_list',
          loadChildren: () => import('./components/user_management/all-user-list/all-user-list.module').then(m => m.AllUserListModule),
          canActivate: [LoginGuard]
        },
        {
          path: 'user_managment/user_add',
          loadChildren: () => import('./components/user_management/user-add/user-add.module').then(m => m.UserAddModule),
          canActivate: [LoginGuard, PrivilegesGuard],
          data:{privilegeKey : 'create_user'}
        },
        {
          path: 'user_managment/user_edit/:id',
          loadChildren: () => import('./components/user_management/user-add/user-add.module').then(m => m.UserAddModule),
          canActivate: [LoginGuard, PrivilegesGuard],
          data:{privilegeKey : 'create_user'}
  
        },
       // Platform Setting   
      {
        path: 'all-apps',
        loadChildren: () => import('./components/application/application.module').then(m => m.ApplicationModule),
        canActivate: [LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'application'}
      },
      {
        path: 'apps-config',
        loadChildren: () => import('./components/application/app-configurations/app-configurations.module').then(m => m.AppConfigurationsModule),
        canActivate: [LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'application'}
      },
      {
        path: 'apps-config/new',
        loadChildren: () => import('./components/application/add-app-config-fields/add-app-config-fields.module').then(m => m.AddAppConfigFieldsModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'apps-config/delete',
        loadChildren: () => import('./components/application/delete-app-config-fields/delete-app-config-fields.module').then(m => m.DeleteAppConfigFieldsModule),
        canActivate: [LoginGuard]
      },
      
      
      {
        path: 'add_item_to_list',
        loadChildren: () => import('./components/add-item-to-list/add-item-to-list.module').then(m => m.AddItemToListModule),
        canActivate: [LoginGuard, PrivilegesGuard],
        data:{privilegeKey : 'add_to_list'}
      },
      
      
      {
        path:'get_smart_url',
        loadChildren:() => import('./components/content_management/manage-smart-url/manage-smart-url.module').then(m => m.ManageSmartUrlModule),
        canActivate: [LoginGuard]
      },
      {
        path:'add_removable_contents',
        loadChildren:() => import('./components/content_management/remove-items/remove-items.module').then(m => m.RemoveItemsModule)
      },
      {
        path:'bulk_list',
        loadChildren:() => import('./components/content_management/bulk-update-info/bulk-update-info.module').then(m => m.BulkUpdateInfoModule)
      },
      {
        path:'media_bulk_upload/:type',
        loadChildren:() => import('./components/bulk-upload/media-bulk-upload/media-bulk-upload.module').then(m => m.MediaBulkUploadModule)
      },
      {
        path:'platform_settings',
        loadChildren: () => import('./components/administration/platform-settings/platform-settings.module').then(m => m.PlatformSettingsModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'platform_settings'}
      },
      {
        path:'administration/roles',
        loadChildren:() => import('./components/administration/roles/roles.module').then(m => m.RolesModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'create_role'}
      },
    
      {
        path:'administration/roles/add_role',
        loadChildren:() => import('./components/administration/roles/add-roles/add-roles.module').then(m => m.AddRolesModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'create_role'}
      },
      {
        path:'administration/roles/edit_role/:id',
        loadChildren:() => import('./components/administration/roles/add-roles/add-roles.module').then(m => m.AddRolesModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'create_role'}
      },
      {
        path:'administration/mail_templates',
        loadChildren: () => import('./components/administration/mail-templates/mail-templates.module').then(m => m.MailTemplatesModule),
        canActivate:[LoginGuard]
      },
      {
        path:'administration/mail_templates/new_template',
        loadChildren: () => import('./components/administration/mail-templates/new-template/new-template.module').then(m => m.NewTemplateModule),
        canActivate:[LoginGuard]
      },
        {
        path:'administration/privilages',
        loadChildren:() => import('./components/administration/privilages/privilages.module').then(m => m.PrivilagesModule),
        canActivate:[LoginGuard],

      },
      {
        path:'administration/privilages/add',
        loadChildren:() => import('./components/administration/privilages/add-privilages/add-privilages.module').then(m => m.AddPrivilagesModule),
        canActivate:[LoginGuard],

      },
      {
        path:'report/subscription_report',
        loadChildren: () => import('./components/report/subscription-report/subscription-report.module').then(m => m.SubscriptionReportModule),
        canActivate:[LoginGuard]
      },
      {
        path:'report/user_report',
        loadChildren: () => import('./components/report/user-report/user-report.module').then(m => m.UserReportModule),
        canActivate:[LoginGuard]
      },
      {
        path:'report/first_purchase_report',
        loadChildren: () => import('./components/report/first-purchase-report/first-purchase-report.module').then(m => m.FirstPurchaseReportModule),
        canActivate:[LoginGuard]
      },
      {
        path:'report/transaction_report',
        loadChildren: () => import('./components/report/transaction-report/transaction-report.module').then(m => m.TransactionReportModule),
        canActivate:[LoginGuard]
      },
      {
        path:'report/notification_report',
        loadChildren: () => import('./components/report/notification-report/notification-report.module').then(m => m.NotificationReportModule),
        canActivate:[LoginGuard]
      },
      {
        path:'report/ingestion_report',
        loadChildren: () => import('./components/report/ingestion-report/ingestion-report.module').then(m => m.IngestionReportModule),
        canActivate:[LoginGuard]
      },
      {
        path:'report/usage_report',
        loadChildren: () => import('./components/report/usage-report/usage-report.module').then(m => m.UsageReportModule),
        canActivate:[LoginGuard]
      },
      {
        path:'coupon/coupon',
        loadChildren: () => import('./components/coupons/coupons/coupons.module').then(m => m.CouponsModule),
        canActivate:[LoginGuard]
      },
      {
        path:'activity_tracker',
        loadChildren: () => import('./components/activity-tracker/activity-tracker.module').then(m => m.ActivityTrackerModule),
        canActivate:[LoginGuard]
      },
      {
        path:'coupon/create_coupon',
        loadChildren: () => import('./components/coupons/create-coupons/create-coupons.module').then(m => m.CreateCouponsModule),
        canActivate:[LoginGuard]
      },
      {
        path:'coupon/edit_coupon/:catalog_id/:content_id',
        loadChildren: () => import('./components/coupons/create-coupons/create-coupons.module').then(m => m.CreateCouponsModule),
        canActivate:[LoginGuard]
      },
      {
        path:'media/new',
        loadChildren: () => import('./components/media/add-media/add-media.module').then(m => m.AddMediaModule),
        canActivate:[LoginGuard]
      },
      {
        path:'transcoding/stats',
        loadChildren: () => import('./components/transcoding/transcoding-stats/transcoding-stats.module').then(m => m.TranscodingStatsModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
      },
      // {
      //   path: 'catalogs/:name/:id',
      //   loadChildren: () => import('./components/transcoding/transcoding-list-of-items/transcoding-list-of-items.module').then(m => m.TranscodingListOfItemsModule),
      //   canActivate:[LoginGuard, PrivilegesGuard],
      //   data:{privilegeKey:'transcode'}
      // },
      {
        path:'transcoding/catalogs/list_of_items/:id',
        loadChildren: () => import('./components/transcoding/transcoding-list-of-items/transcoding-list-of-items.module').then(m => m.TranscodingListOfItemsModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
      },
      {
        path:'transcoding/add_new_media/:id',
        loadChildren: () => import('./components/transcoding/transcoding-add-media/transcoding-add-media.module').then(m => m.TranscodingAddMediaModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
      },
      {
        path:'transcoding/edit_media/:id/:media_id', 
        loadChildren: () => import('./components/transcoding/transcoding-add-media/transcoding-add-media.module').then(m => m.TranscodingAddMediaModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
      },
      {
        path:'transcoding/publish_settings', 
        loadChildren: () => import('./components/transcoding/transcoding-publish-settings/transcoding-publish-settings.module').then(m => m.TranscodingPublishSettingsModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
      },
      {
        path:'transcoding/publish_settings/add', 
        loadChildren: () => import('./components/transcoding/transcoding-publish-settings/add-transcoding-publish-setting/add-transcoding-publish-setting.module').then(m => m.AddTranscodingPublishSettingModule),
        canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
      },
     {
      path :'transcoding/publish_settings/edit/:id',
      loadChildren: () => import('./components/transcoding/transcoding-publish-settings/add-transcoding-publish-setting/add-transcoding-publish-setting.module').then(m => m.AddTranscodingPublishSettingModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },
    {
      path :'transcoding/transcoding_profile_settings',
      loadChildren : () =>import('./components/transcoding/transcoding-profile-settings/transcoding-profile-settings.module').then(m => m.TranscodingProfileSettingsModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },
    {
      path :'transcoding/hls_Player',
      loadChildren : () =>import('./components/transcoding/hls-player/hls-player.module').then(m => m.HlsPlayerModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },
    {
      path :'transcoding/transcoding_profile_settings/add',
      loadChildren : () =>import('./components/transcoding/transcoding-add-profiles/transcoding-add-profiles.module').then(m => m.TranscodingAddProfilesModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },
    {
      path :'transcoding/transcoding_profile_settings/edit/:id',
      loadChildren : () =>import('./components/transcoding/transcoding-add-profiles/transcoding-add-profiles.module').then(m => m.TranscodingAddProfilesModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },

    {
      path :'transcoding/catalogs',
      loadChildren : () =>import('./components/transcoding/transcoding-catalogs/transcoding-catalogs.module').then(m => m.TranscodingCatalogsModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },
    {
      path :'transcoding/catalogs/add',
      loadChildren : () =>import('./components/transcoding/add-new-transcoding-catalog/add-new-transcoding-catalog.module').then(m => m.AddNewTranscodingCatalogModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },
    {
      path :'transcoding/catalogs/edit/:name/:id',
      loadChildren : () =>import('./components/transcoding/add-new-transcoding-catalog/add-new-transcoding-catalog.module').then(m => m.AddNewTranscodingCatalogModule),
      canActivate:[LoginGuard, PrivilegesGuard],
        data:{privilegeKey:'transcode'}
    },
    {
      path:'drm',
      loadChildren : () =>import('./components/DRM/drmlisting/drmlisting.module').then(m => m.DRMListingModule),
      canActivate:[LoginGuard]
    },

    // monetization

    {
      path:'monetization/add-new-content-control',
      loadChildren : () =>import('./components/monetization/add-content-control/add-content-control.module').then(m => m.AddContentControlModule),
      canActivate:[LoginGuard]
    },
    {
      path:'monetization/edit-content-control/:catalog_id/:content_id',
      loadChildren : () =>import('./components/monetization/add-content-control/add-content-control.module').then(m => m.AddContentControlModule),
      canActivate:[LoginGuard]
    },

    {
      path:'monetization/all-content-control',
      loadChildren : () =>import('./components/monetization/content-control-list/content-control-list.module').then(m => m.ContentControlListModule),
      canActivate:[LoginGuard]
    },

    // Subscription plans

    {
      path:'monetization/subscription/end-user-details',
      loadChildren : () =>import('./components/subscription/end-user-details/end-user-details.module').then(m => m.EndUserDetailsModule),
      canActivate:[LoginGuard]
    },
    {
      path:'monetization/subscription/add-end-user',
      loadChildren : () =>import('./components/subscription/add-end-user/add-end-user.module').then(m => m.AddEndUserModule),
      canActivate:[LoginGuard]
    },
    {
      path:'monetization/subscription/transaction-details',
      loadChildren : () =>import('./components/subscription/transaction-details/transaction-details.module').then(m => m.TransactionDetailsModule),
      canActivate:[LoginGuard]
    },
    {
      path:'monetization/subscription/view-all-plans',
      loadChildren : () =>import('./components/subscription/view-all-plans/view-all-plans.module').then(m => m.ViewAllPlansModule),
      canActivate:[LoginGuard]
    },
    {
      path:'monetization/subscription/view-all-plans/add/:catalog_id',
      loadChildren : () =>import('./components/subscription/view-all-plans/add-plans/add-plans.module').then(m => m.AddPlansModule),
      canActivate:[LoginGuard]
    }, 
    {
      path:'monetization/subscription/view-all-plans/addPack/:catalog_id/:id',
      loadChildren : () =>import('./components/subscription/view-all-plans/add-plans/add-pack-component/add-pack-component.module').then(m => m.AddPackComponentModule),
      canActivate:[LoginGuard]
    }, 
    {
      path:'monetization/subscription/view-all-plans/addPack/:catalog_id/:id/:pack_id',
      loadChildren : () =>import('./components/subscription/view-all-plans/add-plans/add-pack-component/add-pack-component.module').then(m => m.AddPackComponentModule),
      canActivate:[LoginGuard]
    }, 
    {
      path:'monetization/subscription/view-pack/:plan-name/:catalog_id/:id',
      loadChildren : () =>import('./components/subscription/view-all-plans/all-pack/all-pack.module').then(m => m.AllPackModule),
      canActivate:[LoginGuard]
    }, 
    {
      path:'monetization/subscription/view-all-plans/TVOD',
      loadChildren : () =>import('./components/subscription/view-all-plans/add-tvodplans/add-tvodplans.module').then(m => m.AddTVODPlansModule),
      canActivate:[LoginGuard]
    },
    {
      path: 'monetization/subscription/view-all-plans/TVOD/edit/:id',
      loadChildren: () => import('./components/subscription/view-all-plans/add-tvodplans/add-tvodplans.module').then(m => m.AddTVODPlansModule),
      canActivate: [LoginGuard],
     
    },
    {
      path: 'monetization/subscription/view-all-plans/edit/:catalog_id/:content_id',
      loadChildren: () => import('./components/subscription/view-all-plans/add-plans/add-plans.module').then(m => m.AddPlansModule),
      canActivate: [LoginGuard],
     
    },
    {
      path:'monetization/subscription/view-all-plans/PriceTag',
      loadChildren : () =>import('./components/subscription/view-all-plans/add-price-tag/add-price-tag.module').then(m => m.AddPriceTagModule),
      canActivate:[LoginGuard]
    },
    
    ]
  },
 



];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled',
    useHash: true,
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
